import { render, staticRenderFns } from "./JobTree.vue?vue&type=template&id=53dd2dc6&scoped=true&"
import script from "./JobTree.vue?vue&type=script&lang=ts&"
export * from "./JobTree.vue?vue&type=script&lang=ts&"
import style0 from "./JobTree.vue?vue&type=style&index=0&id=53dd2dc6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dd2dc6",
  null
  
)

export default component.exports